import LabelInput from 'components/common/LabelInput';
import {validateValuePassword} from 'function/validate';
import {IRegisterInfo} from 'pages/Register';
import React, {useEffect, useState} from 'react';
import {minmax} from 'utils/minmax';

/**
 * 비밀번호 설정 컴포넌트의 Props 인터페이스
 * @property {IRegisterInfo} registerInfo - 등록 정보
 * @property {React.Dispatch<React.SetStateAction<IRegisterInfo>>} setRegisterInfo - 등록 정보 설정 함수
 * @property {React.Dispatch<React.SetStateAction<boolean>>} setEnableButton - 버튼 활성화 상태 설정 함수
 * @property {boolean} [reset] - 재설정 여부
 */
interface props {
  registerInfo: IRegisterInfo;
  setRegisterInfo: React.Dispatch<React.SetStateAction<IRegisterInfo>>;
  setEnableButton: React.Dispatch<React.SetStateAction<boolean>>;
  reset?: boolean;
}

/**
 * 비밀번호 설정 컴포넌트
 * 비밀번호를 입력하고 확인하는 컴포넌트입니다.
 * @param {props} props - 비밀번호 설정 컴포넌트의 props
 * @returns {JSX.Element} 비밀번호 설정 컴포넌트
 */
export default function PasswordSetting({
  registerInfo,
  setRegisterInfo,
  setEnableButton,
  reset,
}: props) {
  // 비밀번호 보이기
  const [isVisiblePassword, setVisiblePassword] = useState<boolean>(false);

  // 에러 메시지
  const [errorTexts, setErrorTexts] = useState({
    password: '',
    checkPassword: '',
  });

  useEffect(() => {
    const asyncFunc = async () => {
      const error = await validateValuePassword({
        values: registerInfo,
        setErrorTexts,
      });
      if (
        registerInfo.password !== '' &&
        registerInfo.checkPassword !== '' &&
        error === ''
      ) {
        setEnableButton(true);
      } else {
        setEnableButton(false);
      }
    };
    asyncFunc();
  }, [registerInfo]);

  return (
    <>
      {/* 비밀번호 */}
      <LabelInput
        labelText={
          reset ? 'newEnterPasswordAndDetail' : 'enterPasswordAndDetail'
        }
        type="password"
        value={registerInfo.password}
        setValue={(e: any) => setRegisterInfo({...registerInfo, password: e})}
        isVisiblePassword={isVisiblePassword}
        setVisiblePassword={setVisiblePassword}
        errorText={errorTexts.password}
        isColumn
        formattedMessageStyle={{fontSize: minmax(16)}}
      />
      {/* 비밀번호 확인 */}
      <LabelInput
        labelText="checkPassword"
        type="password"
        value={registerInfo.checkPassword}
        setValue={(e: any) =>
          setRegisterInfo({...registerInfo, checkPassword: e})
        }
        errorText={errorTexts.checkPassword}
        isColumn
      />
    </>
  );
}
